var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    { staticStyle: { background: "transparent" } },
    [
      _c(
        "v-list-item",
        { staticClass: "px-0" },
        [
          _c(
            "div",
            {
              staticClass: "text-align-end",
              staticStyle: { "flex-grow": "1" },
            },
            [
              _c(
                "v-list-item-avatar",
                { staticClass: "my-auto", attrs: { size: 76 } },
                [_c("v-img", { attrs: { src: _vm.review.img } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item-content",
            {
              staticClass: "text-align-start",
              staticStyle: { "flex-grow": "18" },
            },
            [
              _c("v-rating", {
                staticClass: "mb-0",
                attrs: { value: 5, dense: "", color: "yellow darken-3" },
              }),
              _vm._v(" "),
              _c(
                "v-list-item-title",
                {
                  class: [
                    _vm.$vuetify.breakpoint.smAndDown
                      ? "text-body-2"
                      : "text-h6",
                    "pa-1 white--text ",
                  ],
                  staticStyle: { "white-space": "normal" },
                },
                [_vm._v(_vm._s(_vm.review.content))]
              ),
              _vm._v(" "),
              _c(
                "v-list-item-subtitle",
                {
                  class: [
                    _vm.$vuetify.breakpoint.smAndDown ? null : "text-body-2",
                    "white--text",
                  ],
                },
                [_vm._v("- " + _vm._s(_vm.review.user) + "\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }